<!-- Titre -->
<h2 mat-dialog-title class="popup-title">{{'auth.editPassword' | translate}}</h2>

<!-- Formulaire complet -->
<form [formGroup]="passwordForm" (ngSubmit)="onSave()" class="password-popup-form">

  <!-- Contenu (champs) avec padding -->
  <mat-dialog-content class="popup-content">
    <mat-form-field appearance="fill">
      <mat-label>{{'auth.newPassword' | translate}}</mat-label>
      <input matInput type="password" formControlName="newPassword" required>
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('required')">
        {{'auth.newPasswordRequired' | translate}}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{'auth.confirmPassword' | translate}}</mat-label>
      <input matInput type="password" formControlName="confirmPassword" required>
      <mat-error *ngIf="passwordForm.get('confirmPassword')?.hasError('required')">
        {{'auth.passwordConfirmationRequired' | translate}}
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <!-- Actions (boutons) -->
  <mat-dialog-actions align="end" class="popup-actions">
    <button mat-raised-button type="submit" class="btn-save">
      {{'common.save' | translate}}
    </button>
  </mat-dialog-actions>

</form>
